package com.pincer.client

import com.pincer.core.Logger

/*
Simple pub/sub for the application stack.
I looked at doing this with options from kotlinx.coroutines.flow which is still probably the simplest way.
Working this way for now as I know the JS side of things is happy with the callbacks.
But counts as a big TODO to make this more Kotlin clever.

Jan 24, notes from looking at different kinds of Flow ...

I tried making a version of my original PincerLoader.kt called PincerFlow.kt with a ...
    fun pincerFlow(contract: SessionContract?,pid: String,coroutineScope: CoroutineScope,syncSeconds: Int = 600,log: Logger): Flow<Pincer> = flow<Pincer>
... the body of which was some of the init and sync code, planning to line up emit new versions of the Pincer when it changes.

Then I started looking at StateFlows, though I got a bit confused as to how the logic of the update is internal/external to the flow itself.
The pattern shown in the code-along (https://developer.android.com/codelabs/jetpack-compose-advanced-state-side-effects)
would be something like ...
    private val _localPincerFlow = MutableStateFlow<Pincer>(Pincer())
    val localPincerFlow: StateFlow<Pincer> = _localPincerFlow.asStateFlow()
... to manage access. This is where the update happens "outside" the flow (?) with _localPincerFlow.value = localPincer or some such.
But see https://blog.stackademic.com/state-management-in-kotlin-the-stateflow-and-collections-conundrum-1ce9a6db3d96 for complications
about equality testing and when the update signal gets triggered.

Current thinking:
- keep working with this simple Changes class for pinging updated around the stack, mostly b/c we know that JS likes that
- look at how we can push our regular localPincer (or our viewModel) through a toStateFlow style thing as above just to build the android app
- make sure we think carefully about the data/events flow cycle so that fundementally we are on the right track
- expect to research Flows more later, perhaps with someone who has more experience
*/

typealias OnChange = () -> Unit // no payload atm

class Changes(val log: Logger, var onChange: OnChange? = null) {

    fun listen(onChange: OnChange) {
        if (this.onChange != null) throw RuntimeException("OnChange already setup")
        this.onChange = onChange
    }

    fun emit() {
        if (onChange == null) {
            log.i("Change signal with nobody listening")
        }
        else {
            //log.f("Change signal")
            try { onChange!!() }
            catch (t: Throwable) { log.w("Signal failed", t) }
        }
    }

}
